// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"ZL-z","carouselContainer":"_L-z"};